// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Pretendard-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Pretendard-ExtraBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/Pretendard-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/Pretendard-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/Pretendard-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/Pretendard-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./fonts/Pretendard-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./fonts/Pretendard-ExtraLight.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./fonts/Pretendard-Thin.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Copyright (c) 2021 Kil Hyung-jin, with Reserved Font Name Pretendard.
https://github.com/orioncactus/pretendard

This Font Software is licensed under the SIL Open Font License, Version 1.1.
This license is copied below, and is also available with a FAQ at:
http://scripts.sil.org/OFL
*/

@font-face {
    font-family: 'Pretendard';
    font-weight: 900;
    font-display: swap;
    src: local('Pretendard Black'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
}

@font-face {
    font-family: 'Pretendard';
    font-weight: 800;
    font-display: swap;
    src: local('Pretendard ExtraBold'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
}

@font-face {
    font-family: 'Pretendard';
    font-weight: 700;
    font-display: swap;
    src: local('Pretendard Bold'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff');
}

@font-face {
    font-family: 'Pretendard';
    font-weight: 600;
    font-display: swap;
    src: local('Pretendard SemiBold'), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
}

@font-face {
    font-family: 'Pretendard';
    font-weight: 500;
    font-display: swap;
    src: local('Pretendard Medium'), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff');
}

@font-face {
    font-family: 'Pretendard';
    font-weight: 400;
    font-display: swap;
    src: local('Pretendard Regular'), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
}

@font-face {
    font-family: 'Pretendard';
    font-weight: 300;
    font-display: swap;
    src: local('Pretendard Light'), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff');
}

@font-face {
    font-family: 'Pretendard';
    font-weight: 200;
    font-display: swap;
    src: local('Pretendard ExtraLight'), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff');
}

@font-face {
    font-family: 'Pretendard';
    font-weight: 100;
    font-display: swap;
    src: local('Pretendard Thin'), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff');
}

@media print {
    table.customTable2 th {
        background-color: #e3f2fd;
        -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
    }
}

table.customTable2 th {
    border: 1px solid #ddd;
    padding: 8px;
}

table.customTable2 {
    border-collapse: collapse;
    width: 100%;
}
table.customTable2 th {
    height: 50px;
    background-color: #eff1f0;
    color: #212121;
    text-align: center;
    font-weight: 500;
    border: 1px solid #fff;
    padding: 8px;
}
table.customTable2 td {
    color: #212121;
    padding: 8px;
    border-top: 1px solid #eff1f0;
}
table.customTable2 tr {
    border-right: 1px solid #eff1f0;
}
@media (max-width: 767px) {
    table.customTable2 colgroup {
        display: none;
    }
    .customTable2 tr.columnCont {
        display: grid;
        grid-template-columns: 100px 1fr;
        width: 100%;
        height: auto;
    }
    .customTable2 tr.fullCont {
        display: grid;
    }
    div.scrollCont th,
    .customTable2 td {
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
@media (max-width: 600px) {
    table.customTable2 td {
        font-size: 14px;
        overflow: hidden;
        height: auto;
    }
}
div.scrollCont {
    overflow-x: auto;
    width: 100%;
}
.ck-editor__editable_inline:not(.ck-comment__input *) {
    height: 300px;
    overflow-y: auto;
}
.reqItem {color: #ff0000;}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;;;;;CAOC;;AAED;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,sFAAmF;AACvF;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,0FAA2F;AAC/F;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,qFAAiF;AACrF;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,yFAAyF;AAC7F;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,uFAAqF;AACzF;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,wFAAuF;AAC3F;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,sFAAmF;AACvF;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,2FAA6F;AACjG;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,qFAAiF;AACrF;;AAEA;IACI;QACI,yBAAyB;QACzB,iCAAyB;gBAAzB,yBAAyB;IAC7B;AACJ;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,cAAc;IACd,YAAY;IACZ,6BAA6B;AACjC;AACA;IACI,+BAA+B;AACnC;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,gCAAgC;QAChC,WAAW;QACX,YAAY;IAChB;IACA;QACI,aAAa;IACjB;IACA;;QAEI,gBAAgB;QAChB,gBAAgB;QAChB,uBAAuB;IAC3B;AACJ;AACA;IACI;QACI,eAAe;QACf,gBAAgB;QAChB,YAAY;IAChB;AACJ;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA,UAAU,cAAc,CAAC","sourcesContent":["/*\nCopyright (c) 2021 Kil Hyung-jin, with Reserved Font Name Pretendard.\nhttps://github.com/orioncactus/pretendard\n\nThis Font Software is licensed under the SIL Open Font License, Version 1.1.\nThis license is copied below, and is also available with a FAQ at:\nhttp://scripts.sil.org/OFL\n*/\n\n@font-face {\n    font-family: 'Pretendard';\n    font-weight: 900;\n    font-display: swap;\n    src: local('Pretendard Black'), url('./fonts/Pretendard-Black.woff') format('woff');\n}\n\n@font-face {\n    font-family: 'Pretendard';\n    font-weight: 800;\n    font-display: swap;\n    src: local('Pretendard ExtraBold'), url('./fonts/Pretendard-ExtraBold.woff') format('woff');\n}\n\n@font-face {\n    font-family: 'Pretendard';\n    font-weight: 700;\n    font-display: swap;\n    src: local('Pretendard Bold'), url('./fonts/Pretendard-Bold.woff') format('woff');\n}\n\n@font-face {\n    font-family: 'Pretendard';\n    font-weight: 600;\n    font-display: swap;\n    src: local('Pretendard SemiBold'), url('./fonts/Pretendard-SemiBold.woff') format('woff');\n}\n\n@font-face {\n    font-family: 'Pretendard';\n    font-weight: 500;\n    font-display: swap;\n    src: local('Pretendard Medium'), url('./fonts/Pretendard-Medium.woff') format('woff');\n}\n\n@font-face {\n    font-family: 'Pretendard';\n    font-weight: 400;\n    font-display: swap;\n    src: local('Pretendard Regular'), url('./fonts/Pretendard-Regular.woff') format('woff');\n}\n\n@font-face {\n    font-family: 'Pretendard';\n    font-weight: 300;\n    font-display: swap;\n    src: local('Pretendard Light'), url('./fonts/Pretendard-Light.woff') format('woff');\n}\n\n@font-face {\n    font-family: 'Pretendard';\n    font-weight: 200;\n    font-display: swap;\n    src: local('Pretendard ExtraLight'), url('./fonts/Pretendard-ExtraLight.woff') format('woff');\n}\n\n@font-face {\n    font-family: 'Pretendard';\n    font-weight: 100;\n    font-display: swap;\n    src: local('Pretendard Thin'), url('./fonts/Pretendard-Thin.woff') format('woff');\n}\n\n@media print {\n    table.customTable2 th {\n        background-color: #e3f2fd;\n        print-color-adjust: exact;\n    }\n}\n\ntable.customTable2 th {\n    border: 1px solid #ddd;\n    padding: 8px;\n}\n\ntable.customTable2 {\n    border-collapse: collapse;\n    width: 100%;\n}\ntable.customTable2 th {\n    height: 50px;\n    background-color: #eff1f0;\n    color: #212121;\n    text-align: center;\n    font-weight: 500;\n    border: 1px solid #fff;\n    padding: 8px;\n}\ntable.customTable2 td {\n    color: #212121;\n    padding: 8px;\n    border-top: 1px solid #eff1f0;\n}\ntable.customTable2 tr {\n    border-right: 1px solid #eff1f0;\n}\n@media (max-width: 767px) {\n    table.customTable2 colgroup {\n        display: none;\n    }\n    .customTable2 tr.columnCont {\n        display: grid;\n        grid-template-columns: 100px 1fr;\n        width: 100%;\n        height: auto;\n    }\n    .customTable2 tr.fullCont {\n        display: grid;\n    }\n    div.scrollCont th,\n    .customTable2 td {\n        max-width: 200px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n}\n@media (max-width: 600px) {\n    table.customTable2 td {\n        font-size: 14px;\n        overflow: hidden;\n        height: auto;\n    }\n}\ndiv.scrollCont {\n    overflow-x: auto;\n    width: 100%;\n}\n.ck-editor__editable_inline:not(.ck-comment__input *) {\n    height: 300px;\n    overflow-y: auto;\n}\n.reqItem {color: #ff0000;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
